import { createFeatureSelector } from '../../create-feature-selector';
import { createSelector } from 'reselect';

const featureRootSelector = createFeatureSelector('productsCompareLists');

export const getProductsCompareLists = createSelector(featureRootSelector, (c) => c.data);

const getCurrentCompareList = (groupId: string | null) =>
  createSelector(getProductsCompareLists, (lists) => lists?.find((list) => list.groupId === groupId));

export const getIsInComparison = (groupId: string | null, productId: string) =>
  createSelector(getCurrentCompareList(groupId), (list) => list?.products?.includes(productId) ?? false);

export const getCompareListsError = createSelector(featureRootSelector, (state) => state.error);
